import {MileageFactor} from './mileage-factor.model';

export class AdminContractType {
  id: number;
  brand: string;
  contractCode: string;
  contractPeriod: number;
  contractType: string;
  acceptMileageMax: number;
  acceptMileageMin: number;
  acceptMonthMax: number;
  acceptMonthMin: number;
  maxMileage: number;
  bestType: string;
  isActive: boolean;

  mileageFactors: MileageFactor[] = [];

}
